/**
 * @desc 运单跟踪详情
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.waybillMaster.getWaybillTraceRecord.Params, options?: any) {
  return updateResponse(
    http(URL + `/waybillMaster/getWaybillTraceRecord`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
